import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { LogDetail } from '../../../../../../../types/log.interface';
import { ValueChangeComponent } from './value-change.component';

@Component({
  selector: 'ces-campaign-detail',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ValueChangeComponent],
  templateUrl: './campaign-detail.component.html',
})
export class CampaignDetailComponent {
  private readonly translate = inject(TranslocoService);
  readonly detail = input.required<LogDetail>();

  get attributeName(): string {
    return this.getAttributeDisplayName(this.detail().attribute || '');
  }

  private getAttributeDisplayName(attribute: string): string {
    const attributeKeyMap: Record<string, string> = {
      name: 'history.fields.name',
      comment: 'history.fields.remark',
      timestamp: 'history.fields.timestamp',
      operator: 'history.fields.operator',
      status: 'history.fields.status',
      campaign: 'history.fields.campaign',
    };
    const key = attributeKeyMap[attribute];
    return key ? this.translate.translate(key) : attribute;
  }
}
